export const ExitStatusValues = ['None', 'Finished', 'REL', 'DNC', 'DNF', 'DSQ', 'DNS', 'DNQ', 'LAP'] as const;
export type ExitStatus = (typeof ExitStatusValues)[number];
